var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('block-image-gallery',{attrs:{"title":_vm.data.title,"background-color":_vm.blockColor ? _vm.blockColor : 'dark',"images":_vm.data.images}})}
var staticRenderFns = []

export { render, staticRenderFns }